"use strict";

// Connecting vendors (plugins)
import "./_vendor";

// Functions
import { mobileCheck, burger, dynamicAdaptive, accordion } from "./functions/";

// Components
// import { formValidation } from "./components/";

window.addEventListener("DOMContentLoaded", () => {
  mobileCheck();
  burger();
  accordion(".faq__body", "faq__question", ".faq__wrapper", "active");
  dynamicAdaptive();
});
